<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">

    <div class="toolbar" id="kt_toolbar">
      <app-sub-header :title="title" :breadcrumbs="breadcrumbs"></app-sub-header>
    </div>

    <div class="container-xxl" v-show="!isReady">
      <Loader />
    </div>

    <div v-show="isReady" >
      <div class="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
          <div class="card">
            <div class="card card-custom" >
              <div class="card-header flex-wrap border-0 pt-6 pb-0">
                <div class="card-title">
                  <h3 class="card-label">{{ $t('promo.list') }}</h3>
                </div>
                <div class="card-toolbar">
                  <button v-if="$can('code_promo_create')" @click="openCreateModal" class="btn btn-sm btn-primary m-2" >{{ $t('promo.create') }}</button>
                </div>
              </div>
              <div class="card-body">
                <table class="table align-middle table-row-bordered fs-6 gy-3 " id="kt_datatable_promo" style="margin-top: 13px !important; cursor:pointer">
                  <thead>
                  <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                    <th> {{$t("promo.code")}}</th>
                    <th> {{$t("promo.reduction")}}</th>
                    <th> {{$t("promo.begin_date")}}</th>
                    <th> {{$t("promo.end_date")}}</th>
                    <th> {{$t("promo.max_usage")}}</th>
                    <th> {{$t("promo.already_used")}}</th>
                    <th> {{$t("promo.status")}}</th>
                    <th>{{$t("actions")}}</th>
                  </tr>
                  </thead>
                </table>
              </div>
            </div>


            <div class="modal fade" tabindex="-1" id="createModal">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">{{ $t('promo.new_code') }}</h5>

                    <!--begin::Close-->
                    <div class="modal-icon-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
                      <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                      <span class="svg-icon svg-icon-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                    fill="currentColor"/>
                              <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                    fill="currentColor"/>
                          </svg>
                          </span>
                      <!--end::Svg Icon-->
                    </div>

                    <!--end::Close-->
                  </div>

                  <div class="modal-body">
                    <!--begin:Form-->
                    <form id="kt_modal_new_target_form" @submit.prevent="createPromoData" class="form" >
                      <div class="row">
                        <div class="col-md-12">
                          <!--begin::Label-->
                          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span class="required">{{$t('promo.code')}}</span>
                          </label>
                          <!--end::Label-->
                          <input type="text" required class="form-control form-control-solid" v-model="formCreateData.code_promo" :placeholder="$t('promo.code')" />

                        </div>

                      </div>
                      <p></p>
                      <p></p>

                      <div class="d-flex flex-column mb-4 fv-row">
                        <div class="row">
                          <div class="col-md-6">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{$t('promo.type')}}</span>
                            </label>
                            <select name="type" class="form-select form-select-solid kt_select2"
                                    v-model="formCreateData.type_discount"  data-control="select2"
                                    data-dropdown-parent="#createModal"
                                    data-search="true"
                                    data-allow-clear="true"
                                    :data-placeholder="$t('promo.type')">
                              <option></option>
                              <option v-for="type in getDiscountTypes" :key="type.name" :value="type?.value">{{ type[$i18n.locale] }}</option>
                            </select>
                          </div>

                          <div class="col-md-6"  v-if="formCreateData.type_discount === 'amount'" >
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{ $t('promo.amount') }} {{ currency ? ('(' + currency +')') : ''}}</span>
                            </label>
                            <VueNumberFormat class="form-control form-control-solid" required  v-model:value="formCreateData.reduction"   :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                            ></VueNumberFormat>
                          </div>

                          <div class="col-md-6"  v-if="formCreateData.type_discount === 'percent'">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{ $t('promo.percent') }}</span>
                            </label>

                            <div class="input-group">
                              <input type="number" @keypress="onlyNumber"  step=".01" class="form-control form-control-solid" v-model="formCreateData.reduction" required :placeholder="$t('promo.percent_placeholder')" />
                              <span class="input-group-text" id="basic-addon2">%</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="d-flex flex-column mb-8 fv-row">
                        <div class="row mb-4">
                          <div class="col-md-6 col-sm-12" >
                            <label class="required fs-6 fw-bold mb-2">{{$t('promo.begin_date')}}</label>
                            <!--begin::Input-->
                            <input required class="form-control form-control-solid kt_hbd" v-model="formCreateData.startDate" :placeholder="$t('promo.begin_date')"/>
                            <!--end::Input-->
                          </div>

                          <div class="col-md-6 col-sm-12">
                            <label class="required fs-6 fw-bold mb-2">{{$t('promo.end_date')}}</label>
                            <!--begin::Input-->
                            <input required class="form-control form-control-solid kt_hbd" v-model="formCreateData.endDate" :placeholder="$t('promo.end_date')" />
                          </div>
                        </div>

                        <div class="row mb-5" >
                          <div class="col-md-12 " >
                            <div class="mt-4 form-check form-check-custom form-check-solid">
                                <input class="form-check-input" type="checkbox" v-model="formCreateData.usable_once" id="usable_once_create">
                                <label class="form-check-label fs-6 fw-bold" for="usable_once_create">
                                  {{$t('promo.usable_once')}}
                                  <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" style="margin-left: 5px;" :title="$t('promo.usable_once_info')"></i>
                                </label>
                            </div>
                          </div>

                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{$t('promo.max_usage')}}</span>
                              <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" style="margin-left: 5px;" :title="$t('promo.max_usage_info')"></i>

                            </label>
                            <!--end::Label-->
                            <input type="number" @keypress="onlyNumber"  required class="form-control form-control-solid" v-model="formCreateData.max_usage" :placeholder="$t('promo.max_usage')" />
                          </div>
                          <div class="col-md-6" v-show="formCreateData.usable_once == false">
                            <!--begin::Label-->
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required"> {{$t("promo.use_per_person")}}</span>
                              <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" style="margin-left: 5px;" :title="$t('promo.use_per_person_info')"></i>
                            </label>
                            <!--end::Label-->
                            <input type="number" @keypress="onlyNumber" v-model="formCreateData.use_per_person" class="form-control form-control-solid" :placeholder="$t('promo.use_per_person')" />

                          </div>
                        </div>
                        <div>
                          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span class="">{{$t('promo.description')}}</span>
                          </label>
                          <!--end::Label-->
                          <input type="text"  class="form-control form-control-solid" v-model="formCreateData.description" :placeholder="$t('promo.description')" />
                        </div>
                        <div class="mt-4 form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="checkbox" v-model="formCreateData.status" id="status_create">
                            <label class="form-check-label fs-6 fw-bold" for="status_create">
                              {{$t('promo.status_code')}}
                            </label>
                        </div>

                        <div class="mt-4 form-check form-check-custom form-check-solid" v-if="hasMultipleShops">
                            <input class="form-check-input" type="checkbox" v-model="formCreateData.applies_to_all_shops" id="create_applies_to_all_shops">
                            <label class="form-check-label fs-6 fw-bold" for="create_applies_to_all_shops">
                              {{$t('promo.appliesToAllShops')}}
                            </label>
                        </div>
                        <div v-if="hasMultipleShops && !formCreateData.applies_to_all_shops" class="mt-2">
                          <Select2
                              containerClass=""
                              name="createCodePromoShops"
                              :label="$t('promo.applicableShops')"
                              labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                              :multiple="true"
                              :selectClass="'form-select form-control-solid'"
                              :isRequired="true"
                              :placeholderText="$t('promo.applicableShopsPlaceholder')"
                              v-model="formCreateData.shops">
                            <option v-for="shop in societyShops" :key="shop.id" :value="shop.id">{{ shop.name }}</option>
                          </Select2>
                        </div>

                      </div>

                      <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                        <button type="submit" id="kt_submit_create_code_promo" class="btn btn-sm btn-primary fw-bolder">
                          <span class="indicator-label">{{ $t('button.save') }}</span>
                          <span class="indicator-progress">{{  $t('loading') }}
                          <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                        </button>
                      </div>
                    </form>
                    <!--end:Form-->
                  </div>


                </div>
              </div>
            </div>

            <div class="modal fade" tabindex="-1" id="editModal">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">{{ $t('promo.edit_code') }}</h5>

                    <!--begin::Close-->
                    <div class="modal-icon-close-btn ms-2" data-bs-dismiss="modal" aria-label="Close">
                      <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
                      <span class="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                      fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                      fill="currentColor"/>
                            </svg>
                            </span>
                      <!--end::Svg Icon-->
                    </div>

                    <!--end::Close-->
                  </div>
                  <div class="modal-body">
                    <div class="container-xxl" v-show="isLoadingCodeData">
                      <Loader />
                    </div>
                    <!--begin:Form-->
                    <form v-show="!isLoadingCodeData" id="kt_modal_new_target_form" @submit.prevent="updatePromoData" class="form" >
                      <div>
                        <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span class="">{{$t('promo.status')}}</span>
                        </label>
                        <div class="row " style="margin-bottom:3%">
                          <div class='col-md-4' v-for="(status, index) in getCodePromoStatusFiltered" :key="index">
                            <input type="radio" :value="status?.value" v-model="this.formEditData.status" />
                            {{ status[$i18n.locale] }}
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <!--begin::Label-->
                          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span class="required">{{$t('promo.code')}}</span>
                          </label>
                          <!--end::Label-->
                          <input type="text" required class="form-control form-control-solid" v-model="formEditData.code_promo" :placeholder="$t('promo.code')" />

                        </div>
                      </div>

                      <p></p>
                      <p></p>

                      <div class="d-flex flex-column mb-8 fv-row">
                        <div class="row">
                          <div class="col-md-6">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{$t('promo.type')}}</span>
                            </label>
                            <select name="type" class="form-select form-select-solid kt_select2"
                                    v-model="formEditData.type_discount"  data-control="select2"
                                    data-dropdown-parent="#editModal"
                                    data-search="true"
                                    data-allow-clear="true"
                                    :data-placeholder="$t('promo.type')">
                              <option></option>
                              <option v-for="type in getDiscountTypes" :key="type.name" :value="type?.value">{{ type[$i18n.locale] }}</option>
                            </select>
                          </div>

                          <div class="col-md-6"  v-if="formEditData.type_discount === 'amount'" >
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{ $t('promo.amount') }} {{ currency ? ('(' + currency +')') : ''}} </span>
                            </label>
                            <VueNumberFormat class="form-control form-control-solid" required  v-model:value="formEditData.reduction"   :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                            ></VueNumberFormat>
                          </div>

                          <div class="col-md-6"  v-if="formEditData.type_discount === 'percent'">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{ $t('promo.percent') }}</span>
                            </label>

                            <div class="input-group">
                              <input type="number" @keypress="onlyNumber"  step=".01" class="form-control form-control-solid" v-model="formEditData.reduction" required :placeholder="$t('promo.percent_placeholder')" />
                              <span class="input-group-text" id="basic-addon2">%</span>
                            </div>
                          </div>
                        </div>
                      </div>


                      <div class="d-flex flex-column mb-8 fv-row">
                        <div class="row">
                          <div class="col-md-6 col-sm-12" >
                            <label class="required fs-6 fw-bold mb-2">{{$t('promo.begin_date')}}</label>
                            <!--begin::Input-->
                            <input required class="form-control form-control-solid kt_hbd " v-model="formEditData.startDate" :placeholder="$t('promo.begin_date')" />
                            <!--end::Input-->
                          </div>

                          <div class="col-md-6 col-sm-12">
                            <label class="required fs-6 fw-bold mb-2">{{$t('promo.end_date')}}</label>
                            <!--begin::Input-->
                            <input required class="form-control form-control-solid kt_hbd" v-model="formEditData.endDate" :placeholder="$t('promo.end_date')" />
                          </div>
                        </div>
                        <div class="row mb-5" >
                          <div class="col-md-12 " >
                            <div class="mt-4 form-check form-check-custom form-check-solid">
                              <input class="form-check-input" type="checkbox" v-model="formEditData.usable_once" id="usable_once_edit">
                              <label class="form-check-label fs-6 fw-bold" for="usable_once_edit">
                                {{$t('promo.usable_once')}}
                                <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" style="margin-left: 5px;" :title="$t('promo.usable_once_info')"></i>
                              </label>
                            </div>
                          </div>

                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required">{{$t('promo.max_usage')}}</span>
                              <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" style="margin-left: 5px;" :title="$t('promo.max_usage_info')"></i>
                            </label>
                            <!--end::Label-->
                            <input type="number" @keypress="onlyNumber"  required class="form-control form-control-solid" v-model="formEditData.max_usage" :placeholder="$t('promo.max_usage')" />
                          </div>
                          <div class="col-md-6" v-show="formEditData.usable_once == false">
                            <!--begin::Label-->
                            <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                              <span class="required"> {{$t("promo.use_per_person")}}</span>
                              <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" style="margin-left: 5px;" :title="$t('promo.use_per_person_info')"></i>
                            </label>
                            <!--end::Label-->
                            <input type="number" @keypress="onlyNumber" v-model="formEditData.use_per_person" class="form-control form-control-solid" :placeholder="$t('promo.use_per_person')" />

                          </div>
                        </div>

                        <div style="margin-top:3%">
                          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span class="">{{$t('promo.description')}}</span>
                          </label>
                          <!--end::Label-->
                          <input type="text"  class="form-control form-control-solid" v-model="formEditData.description" :placeholder="$t('promo.description')" />
                        </div>

                        <div class="mt-4 form-check form-check-custom form-check-solid" v-if="hasMultipleShops">
                            <input class="form-check-input" type="checkbox" v-model="formEditData.applies_to_all_shops" id="edit_applies_to_all_shops">
                            <label class="form-check-label fs-6 fw-bold" for="edit_applies_to_all_shops">
                              {{$t('promo.appliesToAllShops')}}
                            </label>
                        </div>
                        <div v-if="hasMultipleShops && !formEditData.applies_to_all_shops" class="mt-2">
                          <Select2
                              containerClass=""
                              name="editCodePromoShops"
                              :label="$t('promo.applicableShops')"
                              labelClass="d-flex align-items-center fs-6 fw-bold mb-2"
                              :multiple="true"
                              :selectClass="'form-select form-control-solid'"
                              :isRequired="true"
                              :placeholderText="$t('promo.applicableShopsPlaceholder')"
                              v-model="formEditData.shops">
                            <option v-for="shop in societyShops" :key="shop.id" :value="shop.id">{{ shop.name }}</option>
                          </Select2>
                        </div>

                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-light btn-light-close" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
                        <button type="submit" id="kt_submit_edit_code_promo" class="btn btn-sm btn-primary fw-bolder">
                          <span class="indicator-label">{{ $t('button.save') }}</span>
                          <span class="indicator-progress">{{  $t('loading') }}
                              <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                        </button>
                      </div>
                    </form>
                    <!--end:Form-->
                  </div>
                </div>
              </div>
            </div>

            <!--end::Card body-->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import {BASE_URL} from "@/services/api";
import {formatDate, formatDateWithSeparator} from '@/mixins/Helper'
import VueNumberFormat from 'vue-number-format'
import CreateCategory from "@/components/Category/CreateCategory";
import CreateVariationModal from "@/components/Variations/CreateVariationModal";
import CreateVariationAttributeModal from "@/components/Variations/CreateVariationAttributeModal";
import {getDiscountTypes} from "@/store/modules/codePromo/getters";
import AppSubHeader from "@/views/Promo/partials/AppSubHeaderIndex";
import {nextTick} from "vue";
import Loader from "@/components/Loader.vue";
import Select2 from '@/components/Select2.vue'


export default {
  components: {AppSubHeader, VueNumberFormat, Loader, Select2},

  data () {
    return {
      title: 'breadcrumbs.promo.promos',
      breadcrumbs: [
        {
          name: 'breadcrumbs.store.dashboard',
          path: '/admin/dashboard'
        },
        {
          name: 'breadcrumbs.promo.list',
          path: '/admin/code-promo'
        },

      ],
      statusBolean:true,
      status:[],
      selected:null,
      options:[],
      currency: '',
      formCreateData: {
          code_promo: '',
          type_discount:'',
          reduction: '',
          startDate: '',
          endDate: '',
          max_usage:'',
          status:true,
          usable_once: true,
          use_per_person:'',
          description:'',
          applies_to_all_shops: true,
          shops: []
      },
      formDeleteData: {
        id: null,
        row: null
      },
      formEditData: {
          id: null,
          code_promo: '',
          type_discount:'',
          reduction: '',
          startDate: '',
          endDate: '',
          max_usage:'',
          status:true,
          usable_once:'',
          use_per_person:'',
          description:'',
          applies_to_all_shops: true,
          shops: []
      },

      isLoadingCodeData: false,
      isReady: false
    }
  },

  watch: {
    '$i18n.locale' : function(value){
      if(value){
        nextTick(() => {
          this.fetchDatas()
        })
      }
    },
    // Usage unique recoché : on vide le nombre d'usages par personne. L'API refuse ce champ
    // quand l'usage est unique (elle applique 1 d'office) ; le laisser rempli donnait une 422.
    'formCreateData.usable_once': function(newVal, oldVal) {
      if (newVal) {
        this.formCreateData.use_per_person = '';
      }
    }

  },

  computed: {
    ...mapGetters('codePromo',['getCodePromoStatus', 'getDiscountTypes']),
    ...mapGetters('society', ['getSocietyShops']),

    locale() {
      return this.$i18n?.locale;
    },
    getCodePromoStatusFiltered() {
      return this.getCodePromoStatus.filter(status => status.name !== "EXPIRED");
    },
    societyShops() {
      return this.getSocietyShops
    },
    hasMultipleShops() {
      return this.getSocietyShops.length > 1
    }
  },

  async mounted() {
    this.isReady = false
    this.initSelect2()
    this.fetchSociety()
    Promise.all([
      this.fetchDatas(),

      this.loadCodePromoStatus(),
      this.getTypeDiscount()
    ]).then(res => this.isReady = true)
        .catch(err => this.isReady = true)

    this.initDatePicker()

    // Écouteurs posés sur le document : retirés en quittant l'écran, sinon ils se cumulent à
    // chaque retour sur la liste (la fenêtre de modification s'ouvrait puis se refermait).
    $(document).off(".codePromoList")
    $(document).on("click.codePromoList", "#kt_datatable_promo .edit_btn", (e) => {

      this.getCodePromoFunction(e.target.getAttribute('data-id'))

      $('#editModal').modal('toggle')
    });

    $(document).on("click.codePromoList", "#kt_datatable_promo .detail_link", (e) => {
      e.preventDefault()
      this.$router.push({ name: 'code-promo-detail', params: { id: e.currentTarget.getAttribute('data-id') } })
    });

    // « Modifier » depuis la page de détail : ouvre directement la fenêtre de modification
    if (this.$route.query.edit && this.$can('code_promo_update')) {
      this.getCodePromoFunction(this.$route.query.edit)
      $('#editModal').modal('show')
      this.$router.replace({ name: 'code-promo-index' })
    }

    $(document).on("click.codePromoList", "#kt_datatable_promo .delete_btn", (e) => {
      this.formDeleteData.id = e.target.getAttribute('data-id')
      this.formDeleteData.row = e.target.getAttribute('data-row')
      this.deleteRow()
    });
    let response = await this.getCurrency()
    this.currency = response.data.currency_symbol ? response.data.currency_symbol : response.data.symbol_native
    this.formCreateData.type_discount = this.getDiscountTypes ? this.getDiscountTypes[0]?.value : ''
  },

  beforeUnmount() {
    $(document).off(".codePromoList")
  },

  methods: {
    ...mapActions('codePromo',
        [
          'createCodePromo',
          'loadCodePromoStatus',
          'getTypeDiscount',
          'updateCodePromo',
          'getCodePromo',
          'deleteCodePromo'
        ]),
    ...mapActions('shop', ['getCurrency']),
    ...mapActions('society', ['fetchSociety']),

    initSelect2() {
      $(".kt_select2").select2();
      $(".kt_select2").change((e) => {
        if (e.target.name === 'type') {
          let type = [];
          for (var k = 0, kLen = e.target.selectedOptions.length; k < kLen; k++) {
            if (e.target.selectedOptions[k]?.value !== '' && e.target.selectedOptions[k]?.value !== undefined) {
              type.push(e.target.selectedOptions[k]?.value);
            }
          }
          this.formCreateData.type_discount = type[0];
          this.formEditData.type_discount = type[0];
        }
      });
    },

    initDatePicker() {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      $(".kt_hbd").flatpickr({
        dateFormat: "d-m-Y",
      });

    },

    async deleteRow() {

      let response = {}
      Swal.fire({
        title: i18n.global.t('swal.codePromo'),
        text: i18n.global.t('swal.text'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('swal.yes'),
        cancelButtonText: i18n.global.t('swal.no'),
      }).then(async (result) => {
        if (result.value) {
          try {
            response = await this.deleteCodePromo(this.formDeleteData.id)
              window.toastr['success'](i18n.global.t("notification.codePromo_deleted"))
              this.table.ajax.reload()
             } catch (e) {
            if (response && response.data) {
              window.toastr['error'](response.data.error)
              return true
            }
          }
        }
      });
    },

    async createPromoData(){
        this.$loading('kt_submit_create_code_promo')
        for (let i=0;i<=this.options.length;i++){
            if(this.options[i]==this.formCreateData.status){
                this.formCreateData.status=this.status[i]?.value
            }
        }

        let response = {}
         try {
            response = await this.createCodePromo({
              ...this.formCreateData,
              status: this.formCreateData.status ? "ACTIVE" : "UNACTIVE",
              // jamais envoyé avec un usage unique, même si le champ masqué garde une valeur
              use_per_person: this.formCreateData.usable_once ? '' : this.formCreateData.use_per_person,
            })
            // statut HTTP plutôt que statusText : ce dernier est vide en HTTP/2 (production),
            // la fenêtre restait alors ouverte alors que le code était bien créé
            if (response.status === 201 || response.status === 200) {
                this.isLoading = false
              //window.toastr['success'](i18n.global.t("notification.user_created"))
               this.formCreateData = {
                  code_promo: '',
                  type_discount:'',
                  reduction: '',
                  startDate: '',
                  endDate: '',
                  max_usage:'',
                  status:'',
                  usable_once:true,
                  use_per_person:'',
                  description:'',
                  applies_to_all_shops: true,
                  shops: []
              }
              $(".kt_select2").select2()
              $(".kt_select2").select2().select2()
              $('#createModal').modal('toggle')
              this.table.ajax.reload()
             this.$stopLoading('kt_submit_create_code_promo')

            }
        }catch(err){
            console.log(err)
            this.$stopLoading('kt_submit_create_code_promo')
            this.isLoading = false;
        }
    },

    openCreateModal() {
      $('#createModal').modal('toggle')
    },

    openEditModal(){
      $(".kt_select2").select2()
      $(".kt_select2").select2().select2()
      $('#editModal').modal('toggle')
    },

    async getCodePromoFunction(id){
        this.isLoadingCodeData = true
          let response = {}
          try {
            response = await this.getCodePromo(id)
            this.formEditData.id = response?.promotion.id
            this.formEditData.code_promo = response?.promotion.code_promo
            this.formEditData.type_discount = response?.promotion.type_discount
            this.formEditData.reduction = response?.promotion.reduction
            this.formEditData.startDate = response?.promotion.startDate
            this.formEditData.endDate =  response?.promotion.endDate
            this.formEditData.max_usage = response?.promotion.max_usage
            this.formEditData.status = response?.promotion.status
            this.formEditData.usable_once = response?.promotion.usable_once
            this.formEditData.use_per_person = response?.promotion.use_per_person
            this.formEditData.description = response?.promotion.description
            this.formEditData.applies_to_all_shops = response?.promotion.applies_to_all_shops !== false
            this.formEditData.shops = (response?.promotion.shops || []).map(shop => shop.id)
            this.isLoadingCodeData = false

            this.$nextTick(() => {
              this.initSelect2()
            })
          } catch(err){
                this.isLoadingCodeData = false
          }
      },

    async updatePromoData(){
      this.$loading('kt_submit_edit_code_promo')
        let response = {}

        try {
          this.formEditData.use_per_person = this.formEditData.usable_once ? '' : this.formEditData.use_per_person
          response = await this.updateCodePromo(this.formEditData)
          $('#editModal').modal('toggle')
          this.table.ajax.reload()
          this.$stopLoading('kt_submit_edit_code_promo')
          return true
        } catch(err){
            this.$stopLoading('kt_submit_edit_code_promo')
            this.isLoading = false;
        }

    },

    // getNameClass(account){
    //   console.log(account)
    //   let voucherStatus =  this.getDiscountTypes.find(stat => stat.value === account)
    //
    //   if(voucherStatus){
    //     return voucherStatus.className
    //   }
    //   return ''
    // },

    getNameInLocale(type){
      let voucherStatus = this.getDiscountTypes?.find(stat => stat?.value === type)
      if(voucherStatus){
        if(this.locale === 'fr'){
          return voucherStatus.fr
        }else{
          return voucherStatus.en
        }
      }
      return ''
    },


    fetchDatas(){
      const AUTH_TOKEN = Ls.get('auth.token')
      this.table = $("#kt_datatable_promo").DataTable({
      destroy: true,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength:Ls.get('pageLength') ?? 10,
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 2, 'desc']],
      ajax: {
      url: BASE_URL+"/get/codePromos/datatable",
      type: "GET",
      beforeSend: function (request) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
      },

      },
      columns: [{ data: "code_promo" },{ data: "reduction" }, { data: "startDate"}, { data: "endDate"},{ data: "max_usage"},{ data: "usage_number"}, {data: 'status'}, { data: "Actions", responsivePriority: -1 }],
      columnDefs: [
        {
            targets: -8,
            order: "desc",
            className: "dt-center clickable",
            render: (t, a, e, l) => {
                // Mobile : les autres colonnes sont repliées par DataTables, on résume donc
                // le code promo ici (réduction, statut, période, usage). Masqué dès 768px.
                const reduction = this.$formatLocalAmount(e.reduction) + " " + (e.type_discount == 'amount' ? this.currency : '%')
                const statusType = this.getStatusClass(e.status)
                const statusName = this.getStatusNameInLocale(e.status)
                return '<a href="javascript:;" data-id="'+ e.id +'" class="detail_link fw-bold text-dark text-hover-primary nameRow'+ l.row +'" title="' + i18n.global.t('promo.detail.view_detail') + '">' + t + "</a>"
                    + `<div class="d-md-none text-start mt-1" style="white-space:normal;">
                         <div class="fs-7 fw-bolder text-gray-800">-${reduction} <span class="badge badge-light-${statusType} ms-1">${statusName}</span></div>
                         <div class="text-muted fs-7">${e.startDate ?? ''} → ${e.endDate ?? ''}</div>
                         <div class="text-muted fs-7">${i18n.global.t('promo.already_used')} : ${e.usage_number ?? 0} / ${e.max_usage ?? '∞'}</div>
                       </div>`;
            }
        },
        {
          targets: -7,
          order: "desc",
          searchable: false,
          className: "dt-center" ,
          render:  (t, a, e, l) =>  {
            return '<span data-id="'+ e.id +'" >' + this.$formatLocalAmount(t) + " " + (e.type_discount == 'amount' ? this.currency : '%') + "</span>";
          },
        },
        {
            targets: -6,
            order: "desc",
            className: "dt-center clickable",
            render: function(t, a, e, l) {
            return '<span data-id="'+ e.id +'" class="beginDateRow'+l.row+'">' + t + '</span>';
            }
        },
        {
          targets: -5,
          order: "desc",
          className: "dt-center clickable",
          render: function(t, a, e, l) {
            return '<span data-id="'+ e.id +'" class="beginDateRow'+l.row+'">' + t + '</span>';
          }
        },

        {
            targets: -4,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'" class="maxUsageRow'+l.row+'">' + t + '</span>';
            }
        },
        {
            targets: -3,
            order: "desc",
            className: "dt-center clickable",
            render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'" class="maxUsageRow'+l.row+'">' + t + '</span>';
            }
        },


        {
          targets: -2,
          orderable:false,
          searchable:false,
          render:  (t, a, e, l) => {
            const type = this.getStatusClass(t)
            let status = this.getStatusNameInLocale(t)
            return '<span data-id="'+ e.id +'" style="font-size:13px; margin:3px; padding:3px" class=" btn btn-sm btn-light-'+ type +'">' + status + "</span>";


          },
        },
          {
              width: "15%",
              targets: -1,
              className: "dt-center",
              title: "Actions",
              orderable: !1,
              render: (t, a, e, l) => {
                let render = `<a href="javascript:;" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon detail_link" title="${i18n.global.t('promo.detail.view_detail')}"><i class="la la-eye fs-2"></i></a>`

                if(this.$can('code_promo_update')){
                  render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon edit_btn" title="${i18n.global.t('button.edit')}"><i data-row="${l.row}" data-id="${e.id}" class="la la-edit fs-2"></i></a>`
                }

                if(this.$can('code_promo_delete')){
                  render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon delete_btn" title="${i18n.global.t('button.delete')}"><i data-row="${l.row}" data-id="${e.id}" class="la la-trash fs-2"></i></a>`
                }

                return render;
              }
          }
      ],
      language: {
      url: this.$i18n?.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json" ,
      }


})
 },

    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },

    getStatusClass(status){

      let promoStatus =  this.getCodePromoStatus?.find(stat => stat?.value === status)

      if(promoStatus){
        return promoStatus.className
      }
      return ''
    },

    getStatusNameInLocale(status){
      let promoStatus = this.getCodePromoStatus?.find(stat => stat?.value === status)
      if(promoStatus){
        if(this.locale === 'fr'){
          return promoStatus.fr
        }else{
          return promoStatus.en
        }
      }
      return ''
    },


  }
}

</script>